import { render, staticRenderFns } from "./BuildYourJewelHome.vue?vue&type=template&id=ba28bf98&scoped=true&"
import script from "./BuildYourJewelHome.vue?vue&type=script&lang=js&"
export * from "./BuildYourJewelHome.vue?vue&type=script&lang=js&"
import style0 from "./BuildYourJewelHome.vue?vue&type=style&index=0&id=ba28bf98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba28bf98",
  null
  
)

export default component.exports